import { useTranslate } from 'react-polyglot';

import { RadioButton } from '@genially/design-system';
import type { AliasMode } from '@genially/p2p-lib';

import { Wrapper } from './AliasModeSelector.styled';

const RADIO_GROUP_NAME = 'session-config-alias-mode';

// Translation keys are written out in full on purpose: building them by interpolating the
// mode would hide them from the translation tooling.
const ALIAS_MODE_OPTIONS: { mode: AliasMode; labelKey: string }[] = [
  {
    mode: 'onJoin',
    labelKey: '__new.play.shared.configuration.modal.aliasMode.onJoin',
  },
  {
    mode: 'onInteract',
    labelKey: '__new.play.shared.configuration.modal.aliasMode.onInteract',
  },
  {
    mode: 'never',
    labelKey: '__new.play.shared.configuration.modal.aliasMode.never',
  },
];

interface AliasModeSelectorProps {
  disabled?: boolean;
  mode: AliasMode;
  onChange: (mode: AliasMode) => void;
}

export const AliasModeSelector = ({
  disabled,
  mode,
  onChange,
}: AliasModeSelectorProps) => {
  const t = useTranslate();

  return (
    <Wrapper>
      {ALIAS_MODE_OPTIONS.map(option => (
        <RadioButton
          key={option.mode}
          checked={mode === option.mode}
          name={RADIO_GROUP_NAME}
          value={option.mode}
          onChange={() => onChange(option.mode)}
          disabled={disabled}
          text={t(option.labelKey)}
        />
      ))}
    </Wrapper>
  );
};
